import React from 'react';
import { ColorPaletteType } from './JRCInputColorRawProps';

import styled from 'styled-components';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { JRCText } from '../../../JRCTypo/JRCTypo';

const SIZE = 20;

const PaletteNameWrapper = styled.div`
    margin: 5px 0;
`;
export const CSSColorBorder = styled.div`
    width: ${SIZE}px;
    height: ${SIZE}px;
    border-radius: 2px;
    background-color: ${(props) => props.theme.color.grey2};
    cursor: pointer;
`;

export const LockIcon = styled.div`
    width: ${SIZE}px;
    height: ${SIZE}px;
    cursor: pointer;
`;
export const CSSColor = styled.div<{ color: string }>`
    width: ${SIZE - 2}px;
    height: ${SIZE - 2}px;
    border-radius: 2px;
    margin: 1px;
    background-color: ${(props) => props.color};
    cursor: pointer;
`;

type ColorPaletteProps = {
    palette: ColorPaletteType;
    isLocked: boolean;
    onClick: (color: string) => void;
    onChange?: (locked: boolean) => void;
};

export const ColorPalette = ({ palette, isLocked = false, onClick, onChange }: ColorPaletteProps) => {
    const [locked, setLocked] = React.useState<boolean>(isLocked);

    React.useEffect(() => {
        if (onChange) {
            onChange(locked);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locked]);

    return (
        <div>
            {palette.name && (
                <PaletteNameWrapper>
                    <JRCText size="s">{palette.name}</JRCText>
                </PaletteNameWrapper>
            )}
            <div
                style={{ flexDirection: 'row', display: 'flex', flexWrap: 'wrap', gap: 2, margin: '5px 0' }}
                data-testid="ColorPalette">
                {palette !== undefined && Array.isArray(palette.colors) ? (
                    palette.colors.map((color, i) => {
                        return (
                            <CSSColorBorder key={`palette-${i}`}>
                                <CSSColor key={color} color={color} onClick={() => onClick(color)} />
                            </CSSColorBorder>
                        );
                    })
                ) : (
                    <></>
                )}
                {onChange ? (
                    <LockIcon
                        onClick={() => {
                            setLocked((currentLocked) => !currentLocked);
                        }}>
                        <JRCIcon name={!locked ? 'icon-unlock' : 'icon-lock'} size={14}></JRCIcon>
                    </LockIcon>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};
